"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestHandler = exports.authenticatedRequester = exports.authRequester = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _errors = require("../errors");

var _config = require("../config");

var _storage = require("./storage");

const authRequester = () => _axios.default.create({
  baseURL: (0, _config.authApi)(),
  headers: {
    accept: 'application/vnd.creditas.v1+json'
  }
});

exports.authRequester = authRequester;

const authenticatedRequester = () => _axios.default.create({
  baseURL: (0, _config.authApi)(),
  headers: {
    accept: 'application/vnd.creditas.v1+json',
    authorization: `Bearer ${(0, _storage.getToken)()}`
  }
});

exports.authenticatedRequester = authenticatedRequester;

const requestHandler = requestFunction => {
  return async (...params) => {
    try {
      return await requestFunction(...params);
    } catch (err) {
      return (0, _errors.handleError)(err);
    }
  };
};

exports.requestHandler = requestHandler;